import { authApi } from "../page/auth/api/authApi";
import { notify } from "./toast";

/**
 * 로그인 세션의 <b>남은 시간</b>을 다루는 공용 지점.
 *
 * <p>만료 시각은 서버가 정해서 로그인·연장 응답으로 내려주고, 화면은 그걸 localStorage 에 들고 있다.
 * 이 값을 읽고 쓰는 곳이 세 군데(로그인·사이드바 타이머·App 의 만료 감시)로 흩어져 있어
 * 키 이름과 단위(millis)를 각자 알고 있어야 했다 — 한 곳만 어긋나도 조용히 안 맞는다.
 */

/** 만료 시각(epoch millis)을 담는 localStorage 키. */
export const SESSION_EXP_KEY = "auth_token_exp";

/** 만료까지 남은 ms. 로그인 상태가 아니거나 만료 시각을 모르면 null. */
export function getSessionTimeLeft() {
    const exp = Number(localStorage.getItem(SESSION_EXP_KEY));
    if (!exp || !localStorage.getItem("auth_token")) return null;
    return Math.max(0, exp - Date.now());
}

/** 만료 시각(epoch millis). 모르면 0 — 호출부가 `if (!exp)` 로 바로 거를 수 있게. */
export function getSessionExpiresAt() {
    return Number(localStorage.getItem(SESSION_EXP_KEY)) || 0;
}

/**
 * 세션 연장 — 서버가 준 새 만료 시각을 반영한다.
 *
 * <p>토스트까지 여기서 띄운다. 호출부가 두 곳(사이드바 버튼, 만료 임박 안내)인데
 * 성공·실패 문구가 갈라지면 같은 동작이 화면마다 달리 보인다.
 *
 * @returns {Promise<boolean>} 연장 성공 여부
 */
export async function extendSession() {
    try {
        const data = await authApi.extend();
        if (!data?.expiration) {
            notify("세션 연장에 실패했습니다.", "error");
            return false;
        }
        localStorage.setItem(SESSION_EXP_KEY, String(data.expiration));
        notify("로그인 시간이 연장되었습니다.", "success");
        return true;
    } catch {
        // 토큰이 이미 죽었으면 401 — 연장할 세션이 없다. 만료 처리는 App 의 감시가 맡는다.
        notify("세션 연장에 실패했습니다.", "error");
        return false;
    }
}
